import { IJsonSerializable } from '../util/interfaces'

import { OpPackageStatus } from '../core/op-package-status'

import { TypeHelper } from '../../helpers/type-helper'

export class OpPackageStatusFlow implements IJsonSerializable {

    // Members

    public packageStatus: OpPackageStatus = null
    public changeStatus: OpPackageStatus[] = []

    // Members


    // Ctor

    public constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    // Ctor End


    // IJsonSerializable Implementation
    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {

            if (compressed || TypeHelper.isJSONCompressed(opObj)) { // ???
                this.packageStatus = opObj.PackageStatus != null ? new OpPackageStatus(opObj.P) : null
                this.changeStatus = opObj.ChangeStatus != null ? opObj.C.map((packageStatusObj: any) => new OpPackageStatus(packageStatusObj)) : null
            } 
            else {
                this.packageStatus = opObj.PackageStatus != null ? new OpPackageStatus(opObj.PackageStatus) : null
                this.changeStatus = opObj.ChangeStatus != null ? opObj.ChangeStatus.map((packageStatusObj: any) => new OpPackageStatus(packageStatusObj)) : null
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result: any = {
                P: this.packageStatus != null ? this.packageStatus.toJSON(true) : null,
                C: this.changeStatus != null ? this.changeStatus.map((packageStatus: OpPackageStatus) => packageStatus.toJSON(compressed)) : null,
            }

            TypeHelper.setJSONCompressedFlag(result)
            TypeHelper.deleteNulls(result)

            return result
        } 

        return {
            PackageStatus: this.packageStatus != null ? this.packageStatus.toJSON() : null,
            ChangeStatus: this.changeStatus != null ? this.changeStatus.map((packageStatus: OpPackageStatus) => packageStatus.toJSON(compressed)) : null
        }
    }

    // IJsonSerializable Implementation End
}